import { FC } from 'react'
import { Lead } from '@/api/types/crm.types'
import cn from 'classnames'
import { getLeadFieldValue } from '@pages/Admin/CRM/utils/leadFields'
import SelectNewStatus from '../../components/SelectNewStatus/SelectNewStatus'
import LeadField from '../../components/LeadField/LeadField'
import { Checkbox } from 'antd'
import { useCRMContext } from '@pages/Admin/CRM/CRMContext'
import mclasses from '../../../../styles/modal.module.css'
import iclasses from '../../../../styles/input.module.css'
import gclasses from '../../../../../CRMSettings/global.module.css'
import cclasses from '@pages/Admin/CRM/styles/checkbox.module.css'
import classes from './index.module.css'
import useFullLeadModalAccess from '../../hooks/useFullLeadModalAccess'

interface MainInfoBlockProps {
  lead?: Lead
  fieldsData: Record<string, string>
  updateFieldData: (uniqueNameField: string, value: string) => void
}

const MainInfoBlock: FC<MainInfoBlockProps> = ({
  lead,
  fieldsData,
  updateFieldData,
}) => {
  const {
    preloadingData: { fields: allFields },
  } = useCRMContext()
  const { currentRole, ...access } = useFullLeadModalAccess()
  if (!lead) return null

  const skipFields = ['ID', 'NAME', 'STATUS', 'DATEL', 'DATEZ']
  const requiredVisibleFields = allFields.filter(
    (field) =>
      field.is_active &&
      field.is_default &&
      !skipFields.includes(field.unique_name),
  )

  return (
    <div className={cn(classes.mainInfoBlock, classes.gapM)}>
      <div className={cn(classes.horizontalList, classes.gapM)}>
        <div className={classes.leadId}>
          {`ID ${getLeadFieldValue(lead, 'ID')}`}
        </div>
        <SelectNewStatus leadId={lead.id} className={classes.statusSelect} />
      </div>
      <div
        className={cn(
          classes.horizontalList,
          classes.gapM,
          classes.requiredFields,
        )}
      >
        {requiredVisibleFields.map((field) => {
          const defaultValue = getLeadFieldValue(lead, field.unique_name) ?? ''
          const currentValue = fieldsData[field.unique_name] ?? ''

          return (
            <LeadField
              key={field.id}
              field={field}
              value={fieldsData[field.unique_name] ?? ''}
              onChange={(val) => updateFieldData(field.unique_name, val)}
              fieldSettings={{
                phoneNumber: {
                  withIntegrations: access.canInteractWithIntegrations &&
                    !!defaultValue &&
                    currentValue === defaultValue && {
                      lead,
                      fieldId: field.id,
                      fieldSettings: field.settings,
                    },
                },
              }}
              disabled={!access.canEditFields}
            />
          )
        })}
      </div>
    </div>
  )
}

export default MainInfoBlock
